/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns;

  ns = window.nspace("ccc.profileSelection");

  /**
   * Renders the page's categories expanded/collapsed state.
   */
  ns.IndicatorSelectionTreeView = Backbone.View.extend({
    initialize: function() {
      _.bindAll(this);

      this.model.once("change", this.render);
      this.model.on("change:locationType change:categories", this.render);
    },

    events: {
      "click .indicator-tree-toggle": "toggleAll",
      "click li[data-top-category] .indicator-list-link:not(.disabled)":
        "toggleIndicators"
    },

    /**
     * Toggles the expand/collapse state of the category/indicator dropdowns.
     */
    toggleIndicators: function(e) {
      var $self, $catNode, id, categories, categoryInCollection;

      $self = $(e.currentTarget);
      $catNode = $self.closest("li[data-top-category]");
      id = +$catNode.data("category-id");

      categories = _.clone(this.model.get("categories"));
      categoryInCollection = _.any(categories, function(category) {
        return +category === id;
      });

      if (categoryInCollection) {
        categories = _.reject(categories, function(category) {
          return +category === id;
        });
      }
      else {
        categories.push(id);
      }

      this.model.set("categories", categories);
    },

    /**
     * Gets the top level category links.
     */
    $topLevelCategories: function() {
      return this.$(
        "li[data-top-category]:has(.indicator-list-link:first:not(.disabled))"
      );
    },

    /**
     * Determines whether all categories are already expanded.
     */
    allApplicableCategoriesAreExpanded: function() {
      var $topLevelCategories, categories;

      $topLevelCategories = this.$topLevelCategories();
      categories = _.clone(this.model.get("categories"));

      return $topLevelCategories.length === categories.length;
    },

    /**
     * Toggles expand/collapse for all category dropdowns.
     */
    toggleAll: function(e) {
      var newIds;
      var self = this;
      // if the number of selectedCategories in the model is equal to the
      // number of li's in the view, collapse; otherwise, expand
      if (this.allApplicableCategoriesAreExpanded()) {
        // collapse
        this.model.set("categories", []);
      }
      else {
        self.suppressLPIndicatorExpansion = true;

        // Tracks when a user clicks the "Expand All" button on the "Create Location Profiles" page
        dataLayer.push({
          event: "LP Expand All",
          eventCategory: "Interactive Clicks",
          eventAction: "LP Expand All",
          eventLabel: window.location.pathname
        });

        newIds = this.$topLevelCategories()
          .map(function() {
            var $self;

            $self = $(this);
            return +$self.data("category-id");
          })
          .get();
        this.model.set("categories", newIds);

        self.suppressLPIndicatorExpansion = false;
      }
    },

    /**
     * Toggles the disabled status of each category.
     */
    toggleCategoryDisabledStatus: function() {
      var self, locationType, elementsToDisable, elementsToEnable;

      self = this;
      elementsToDisable = [];
      elementsToEnable = [];

      locationType = self.model.get("locationType");

      if (!locationType || locationType === "n") {
        return;
      }

      this.$("li[data-top-category]").each(function() {
        var $self, locTypeIds, isCategoryApplicableToLocationType;

        $self = $(this);
        var str = $self.data("loctype-ids").toString();
        if (str.indexOf(",") > -1) {
          locTypeIds = str.split(",");
        }
        else {
          locTypeIds = str;
        }

        isCategoryApplicableToLocationType = _.any(locTypeIds, function(
          locTypeId
        ) {
          return +locTypeId === +self.model.get("locationType");
        });

        if (isCategoryApplicableToLocationType) {
          elementsToEnable.push(this);
          return;
        }

        if ($self.children(".disabled:first").length) {
          return;
        }

        elementsToDisable.push(this);
      });

      // If any elements should be disabled, reset our indicator collection
      // so that an invalid combination of locations/indicators aren't selected.
      if (elementsToDisable.length) {
        self.model.set("indicators", []);
      }

      $(elementsToDisable).each(function() {
        var $self;

        $self = $(this).prop(
          "title",
          "Not available for the selected location"
        );
        $self
          .find(".indicator-list-link")
          .addClass("disabled")
          .removeClass("active")
          .next()
          .slideUp(700);
      });

      $(elementsToEnable).each(function() {
        var $self;

        $self = $(this).prop("title", "");
        $self.find(".indicator-list-link").removeClass("disabled");
      });
    },

    /**
     * Renders the expansion/collapsing of any selected categories.
     */
    expandSelectedCategories: function() {
      var categories;
      var self = this;

      categories = this.model.get("categories");

      this.$("li[data-top-category]").each(function() {
        var $self, shouldBeExpanded, isExpanded;

        $self = $(this);

        if ($self.children(".disabled:first").length) {
          return;
        }

        shouldBeExpanded = _.any(categories, function(category) {
          return +category === +$self.data("category-id");
        });
        isExpanded =
          $self
            .children("div")
            .stop(true, true)
            .css("display") !== "none";

        if (shouldBeExpanded === isExpanded) {
          return;
        }

        if (shouldBeExpanded) {
          var $indicatorListLink = $self.find(".indicator-list-link");
          $indicatorListLink
            .addClass("active")
            .next()
            .stop(true, true)
            .slideDown(700);

          if (!self.suppressLPIndicatorExpansion) {
            // Tracks clicks on indicator expansion (Demographics, Economic Conditions, etc) on the "Location Profile" page
            var categoryName = $indicatorListLink.text().trim();
            dataLayer.push({
              event: "LP Indicator Expansion",
              eventCategory: "Interactive Clicks",
              eventAction: "Indicator Expansion|" + categoryName,
              eventLabel: window.location.pathname
            });
          }
          return;
        }

        $self
          .find(".indicator-list-link")
          .removeClass("active")
          .next()
          .stop(true, true)
          .slideUp(700);
      });
    },

    /**
     * Makes sure the text of the Expand All button is in sync with the expanded categories.
     */
    toggleExpandAll: function() {
      var $toggle;

      $toggle = this.$(".indicator-tree-toggle");
      if (this.allApplicableCategoriesAreExpanded()) {
        $toggle.text("Collapse All");
        return;
      }

      $toggle.text("Expand All");
    },

    render: function() {
      this.toggleCategoryDisabledStatus();
      this.expandSelectedCategories();
      this.toggleExpandAll();
    }
  });
})(jQuery, _);
